// Pagination.js
import React from 'react'
import ReactPaginate from 'react-paginate'

const Pagination = ({ currentPage, onPageChange, totalPages }) => {
  return (
    <div className="row mt-3">
      <div className="col-12">
        <ReactPaginate
          onPageChange={onPageChange}
          // initialPage={currentPage - 1} // Start from page 1
          forcePage={currentPage - 1}
          pageCount={totalPages}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          previousLabel="previous"
          nextLabel="next"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination justify-content-end"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          activeClassName="active"
        />
      </div>
    </div>
  )
}

export default Pagination
